import * as updatePeriodById from "@/api/periods/update";

export default {
	namespaced: true,
	state: {
		period: {},
		id: "",
		error: null,
	},
	getters: {
		readPeriod: (state) => state.period,
		readId: (state) => state.id,
		readError: (state) => state.error,
	},
	mutations: {
		SET_PERIOD(state, payload) {
			state.period = payload;
		},
		SET_ID(state, payload) {
			state.id = payload;
		},
		SET_ERROR(state, payload) {
			state.error = payload;
		},
	},
	actions: {
		async updatePeriod({ commit, getters, rootGetters }) {
			const token = rootGetters['loginStore/readToken'];
			const updatePeriodRes = await updatePeriodById
				.updatePeriod(token,getters.readId, getters.readPeriod)
				.then(() => {
					return true;
				})
				.catch((error) => {
					if (error.response) {
						let message =
							error.response.data.message ||
							error.response.data.detail[0].msg;
						message == "Token expired"
							? commit("loginStore/SET_ACCESS_TOKEN", null, {
									root: true,
							  })
							: message
							? commit("SET_ERROR", message)
							: commit("SET_ERROR", "Algo salió mal");
					} else {
						console.log(error);
						commit("SET_ERROR", error);
					}
				});

			return updatePeriodRes;
		},
	},
};
